import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'
import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'

ClosureSurvey.SubmitFeedback = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    onStepProgression()
  },

  buttonLayout: function() {
    return 'none'
  },

  component: React.createClass({
    componentDidMount: function() {
      this.createJobClosure()
    },

    createJobClosure: function() {
      let surveyData = ClosureSurveyData.Data

      if ( ClosureSurveyData.Data.value === null ) {
        surveyData.value = this.props.amountPaid
      }

      $.ajax({
        url: `/jobs/job/${this.props.jobId}/closure`,
        type: 'PUT',
        dataType: 'json',
        data: {
          survey: {
            closure: {
              outcome: surveyData.outcome,
              provider_account_id: surveyData.providerAccountId,
              value: surveyData.value
            },
            closure_history: {
              trigger: this.props.trigger,
              medium: this.props.medium
            },
            feedback: {
              rating: surveyData.rating,
              comments: surveyData.comments
            },
            feedback_reasons: surveyData.selectedReasons,
            from_fast_feedback: this.props.fromFastFeedback
          }
        }
      }).done((data) => {
        ClosureSurvey.Emitter.emit('closureSurvey:wizard:advanceToStep', ClosureSurvey.JobStatusUpdated)
      }).fail((jqXHR, textStatus) => {
        if (this.props.iosHref !== null && typeof this.props.iosHref !== "undefined") {
          window.location = this.props.iosHref
          SS.appFn.appMsg('Survey submitted')
          $('#job-closure-modal').modal('hide')
        }
        else {
          document.location.href =`/jobs/${this.props.jobId}`
        }    
      })
    },

    render: function() {
      return (
        <div className="modal-body job-closure-form-body">
          <h3>Saving feedback details...
            <div className="spinner-icon text-center" style={{marginLeft: '15px'}}/>
          </h3>
        </div>
      )
    }
  })
}
